package com.tovtalk.domain.entity

import kotlin.time.Instant

/**
 * Chat Thread - שיחה עם משתמש
 */
data class ChatThread(
    val conversationId: String,
    val otherUser: User,
    val lastMessage: Message?,
    val unreadCount: Int = 0,
    val chatType: ChatType,
    val isDeleted: Boolean = false,
    val updatedAt: Instant
)

/**
 * Message - הודעה בצ'אט
 * receivedAt = when receiver got the message; readAt = when receiver opened the conversation.
 */
data class Message(
    val id: String,
    val conversationId: String,
    val senderId: Int,
    val receiverId: Int,
    val content: String?,
    val isDeleted: Boolean = false,
    val createdAt: Instant,
    val receivedAt: Instant? = null,
    val readAt: Instant? = null
)

/**
 * Chat Type
 */
enum class ChatType(val value: String) {
    APPROVED("approved"),
    REQUESTED("requested");

    companion object {
        fun fromString(value: String) = entries.find { it.value == value } ?: REQUESTED
    }
}
